import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { label: "회사", href: "company/index.html" },
  { label: "협력업체 모집", href: "dealer/index.html" },
  { label: "제품", href: "#product" },
  { label: "특징", href: "#features" },
  { label: "스펙", href: "#specs" },
  { label: "영상", href: "#videos" },
  { label: "설명서", href: "#manual" },
  { label: "설치", href: "#install" },
  { label: "FAQ", href: "#faq" },
  { label: "문의", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (href: string) => {
    setMenuOpen(false);
    if (!href.startsWith("#")) {
      window.location.href = `${__BASE_PATH__}${href}`;
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <button
            type="button"
            onClick={() => handleAnchor("#top")}
            className={`flex items-center gap-2 cursor-pointer whitespace-nowrap ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <span className="font-heading font-bold text-lg tracking-widest">
              LRGS1 X9PRO
            </span>
          </button>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.href}
                type="button"
                onClick={() => handleAnchor(item.href)}
                className={`text-sm font-medium cursor-pointer whitespace-nowrap transition-colors hover:text-primary-500 ${
                  scrolled ? "text-foreground-800" : "text-background-100"
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => handleAnchor("#contact")}
              className="hidden md:inline-flex items-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 px-4 py-2 text-sm font-semibold cursor-pointer whitespace-nowrap transition-colors"
            >
              <i className="ri-mail-line"></i>
              1:1 상담
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
                scrolled
                  ? "text-foreground-950 bg-background-100"
                  : "text-background-50 bg-background-950/40"
              }`}
              aria-label="메뉴 열기"
            >
              <i className={`ri-${menuOpen ? "close" : "menu"}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70">
          <div className="flex flex-col p-4 gap-1">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.href}
                type="button"
                onClick={() => handleAnchor(item.href)}
                className="text-left px-3 py-3 rounded-md text-foreground-900 hover:bg-background-100 cursor-pointer text-sm font-medium whitespace-nowrap"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
